import { useCallback } from 'react';

import { useQuery } from 'react-query';

import { KimMessage } from '../../../../backend/src/matter/subset/thread/kim-message.entity';
import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetKimMessages = (matterId?: string, subsetId?: string, threadId?: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  const fetchKimMessages = async () => {
    const res = await fetch(
      `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/messages`,
      fetchConfigGET,
    );
    if (!res.ok) {
      const error = await res.json();
      throw new ApiError(error.code, error.message);
    }
    return res.json();
  };

  const query = useQuery<KimMessage[], ApiError>(
    [QueryEntity.KimMessages, { subsetId, threadId }],
    async () => fetchKimMessages(),
    {
      enabled: !!matterId && !!subsetId && !!threadId,
    },
  );

  // Direct fetch that bypasses the React Query cache.
  const fetchFresh = useCallback(async (): Promise<KimMessage[]> => {
    return await fetchKimMessages();
  }, [matterId, subsetId, threadId, fetchConfigGET]);

  return { ...query, fetchFresh };
};
